import { Trophy, Clock, Upload } from "lucide-react";
import { Countdown } from "./Countdown";

export const PRIZES = ["$5,000", "$2,500", "$1,250"];

const STEPS = [
  ["Sube tu león", "Foto de tu león pintado con tu nombre, correo y celular."],
  ["Vota por 3", "1º lugar = 3 puntos, 2º = 2 puntos, 3º = 1 punto."],
  ["Ganan los que sumen más", "1º lugar $5,000 · 2º $2,500 · 3º $1,250 MXN."],
];

export const Hero = ({ config }) => (
  <>
    <div className="picado" aria-hidden="true">
      {Array.from({ length: 40 }).map((_, i) => <span key={i} />)}
    </div>
    <header className="hero">
      <div className="wrap">
        <div className="brand">Trafalgar<i>.</i></div>
        <h1 data-testid="hero-title">Pinta tu <em>León</em></h1>
        <div className="sub">Halloween · Día de Muertos</div>
        <div className="prizes" data-testid="prize-badges">
          {PRIZES.map((p, i) => (
            <div className={`prize${i ? " alt" : ""}`} key={p} data-testid={`prize-${i + 1}`}>
              {i === 0 && <Trophy size={18} />}{i + 1}º lugar · {p} MXN
            </div>
          ))}
        </div>
        <div className="deadlines" data-testid="deadlines">
          <div className="deadline" data-testid="upload-deadline">
            <Upload size={16} /> Subir tu león: hasta el <b>jueves 5 de noviembre, 12:00</b> (CDMX)
            {config?.uploadDeadline && <Countdown deadline={config.uploadDeadline} closedText="Registro cerrado" testid="upload-countdown" />}
          </div>
          <div className="deadline" data-testid="voting-deadline">
            <Clock size={16} /> Votar (puedes cambiar tu voto): hasta el <b>viernes 6 de noviembre, 12:00</b> (CDMX)
            {config?.deadline && <Countdown deadline={config.deadline} closedText="Votación cerrada" testid="voting-countdown" />}
          </div>
        </div>
        <div className="steps">
          {STEPS.map(([t, d], i) => (
            <div className="step" key={t} style={{ animationDelay: `${i * 90}ms` }}>
              <span className="n">{i + 1}</span><b>{t}</b>{d}
            </div>
          ))}
        </div>
      </div>
    </header>
  </>
);
